import React from 'react';

/**
 * Shared page frame for top-level tab pages, codifying the app's "Alerts-style"
 * layout contract so every tab is visually consistent:
 *  - centered, width-capped frame (max-w-6xl mx-auto)
 *  - base horizontal padding on mobile (px-2) → px-4 on desktop, so content is
 *    never flush against the screen edge
 *  - vertical rhythm via space-y
 *
 * Use TabPageShell as the outer wrapper and TabPageHeader for the title block.
 */
export const TabPageShell: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={`mx-auto w-full max-w-6xl px-2 py-4 md:px-4 md:py-6 ${className ?? ''}`}>
    <div className="space-y-4 md:space-y-6">{children}</div>
  </div>
);

/**
 * Centered icon + title + subtitle header matching the Alerts/Admin/Settings
 * pattern: `h2 text-lg md:text-2xl font-bold` with an optional icon, centered.
 */
export const TabPageHeader: React.FC<{
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
}> = ({ title, subtitle, icon }) => (
  <header className="text-center">
    <h2 className="flex items-center justify-center gap-2 text-lg font-bold text-text-primary md:text-2xl">
      {icon}
      <span>{title}</span>
    </h2>
    {subtitle && <p className="mt-1 text-xs text-text-muted md:text-base">{subtitle}</p>}
  </header>
);

export default TabPageShell;
